import { AmendmentEvent } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface AmendmentCellDisplayProps {
  value: any
}

export const AmendmentCellDisplay = ({ value }: AmendmentCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/AmendmentEditor')

  if (value?.input?.events?.length) {
    return (
      <Tooltip
        title={
          <Stack spacing={1} padding={1}>
            {value.input?.events?.map(
              ({ date, amendmentType, method, rate, units }: AmendmentEvent, index: number) => (
                <Stack key={index}>
                  <Typography variant="body1">
                    {t('eventDate', { date: new Date(date) })}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'background.default' }}>
                    {t(`type_${amendmentType}`)} - {t(`method_${method}`)}{' '}
                    {t('eventRate', { rate })} {t(`units_${units}`)}
                  </Typography>
                </Stack>
              )
            )}
          </Stack>
        }
      >
        <Typography variant="body1">
          {t('events', { count: value.input?.events?.length })}
        </Typography>
      </Tooltip>
    )
  }

  return <Typography>{t('none')}</Typography>
}
